<h1>Testing the internet</h1>


<ul class="bargraph" style="width: {(16 + 2) * maxBars}px;">
  <li class="column" style="margin-left: {-16+paddingLeft}px">
  </li>{#each speeds as s, i (s.id)}
    <li class="column">
      <div class="bar" data-id="{s.id}" style={s.style}>&nbsp;</div>
    </li>
  {/each}
</ul>

<p>time: {newMeasure.speed}</p>


<style>
  h1 {
    color: purple;
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }


  .bargraph {
    position: relative;
    height: 100px;
    border: 1px solid black;
    padding: 2px 1px;
    overflow: hidden;
    white-space: nowrap;
  }

  .column {
    position: relative;
    display: inline-block;
    width: 16px;
    
    margin: 0 1px;
    height: 100px;
    background-color: #ececec;
  }

  .bar {
    position: absolute;
    border: 0.5px solid black;
    width: 15px;
    bottom: 0;
  }
</style>
